import { render, staticRenderFns } from "./linkcodes.vue?vue&type=template&id=d958987a&scoped=true&"
import script from "./linkcodes.vue?vue&type=script&lang=js&"
export * from "./linkcodes.vue?vue&type=script&lang=js&"
import style0 from "./linkcodes.vue?vue&type=style&index=0&id=d958987a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d958987a",
  null
  
)

export default component.exports